import { Alert } from 'avo-ui'
import { ThankYou } from 'components/award/thank-you/ThankYou'
import { useValidation } from 'hooks/useValidation'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { API_AWARD } from 'services/apiAward'
import { METHOD } from 'services/method'
import { useFetch } from 'services/useFetch'
import { uploadFileToS3 } from 'utils/utils'

const INITIAL_STATE = {
    title: null,
    countdown: null,
    desktop_background: null,
    mobile_background: null,
}

const DEFAULT_TIME = '00:00'

export const ThankYouContainer = () => {
    const [form, setForm] = useState(INITIAL_STATE)
    const [isLoadingUpload, setLoadingUpload] = useState(false)
    const { fetching: getThankYouPage, isLoading } = useFetch(API_AWARD.THANK_YOU_PAGE)
    const { fetching: updateThankYouPage, isLoading: isUpdating } = useFetch({
        ...API_AWARD.THANK_YOU_PAGE,
        method: METHOD.PUT,
    })
    const { fetching: getURLImage } = useFetch(API_AWARD.URL_AWARD_IMAGE)
    const { isFormValid } = useValidation({ form: form })

    useEffect(() => {
        fetchThankYou()
    }, [])

    const fetchThankYou = async () => {
        const response = await getThankYouPage()
        const { countdown, ...rest } = response?.data || {}
        setForm({
            ...rest,
            ...(countdown && {
                date: moment(countdown).format('YYYY-MM-DD'),
                time: moment(countdown).format('HH:mm'),
                countdown: moment(countdown).format('YYYY-MM-DD HH:mm'),
            }),
        })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        if (name === 'date') {
            return setForm({ ...form, [name]: value, countdown: `${value} ${form?.time || DEFAULT_TIME}` })
        }
        if (name === 'time') {
            return setForm({ ...form, [name]: value, countdown: `${form.date} ${value || DEFAULT_TIME}` })
        }
        setForm({ ...form, [name]: value })
    }

    const handleUploadImage = async (files) => {
        let newFormImage = {}
        const fileNames = Object.entries(files).map(([key, item]) => item.name)

        const s3Urls = await getURLImage({ files: fileNames })
        const newEntries = Object.entries(files).map(([key, item], index) => {
            return [key, { ...item, ...s3Urls?.data?.[index] }]
        })

        const s3UrlsWithKey = Object.fromEntries(newEntries)
        await Promise.all(
            Object.entries(s3UrlsWithKey).map(async ([key, item], index) => {
                await uploadFileToS3(item, item.file)
                newFormImage = {
                    ...newFormImage,
                    [key]: `${s3UrlsWithKey?.[key]?.url}${s3UrlsWithKey?.[key]?.fields?.key}`,
                }
            }),
        )
        setLoadingUpload(false)
        return newFormImage
    }

    const onSubmit = async () => {
        let files = {}
        if (form?.desktop_background?.file) files = { ...files, desktop_background: form?.desktop_background }
        if (form?.mobile_background?.file) files = { ...files, mobile_background: form?.mobile_background }

        let payload = { ...form, countdown: moment(form?.countdown).utc().format('YYYY-MM-DD HH:mm') }
        delete payload.date
        delete payload.time

        if (Object.entries(files).length > 0) {
            setLoadingUpload(true)
            payload = {
                ...payload,
                ...(await handleUploadImage(files)),
            }
        }

        await updateThankYouPage(payload)
        await fetchThankYou()
        Alert({
            icon: 'success',
            title: 'Success',
            message: 'Thank You Page Updated!',
        })
    }

    const props = {
        data: form,
        onChangeForm,
        isFormValid,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <ThankYou {...props} />
}
